// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Timer_countdown__24GCm","TimerBox":"Timer_TimerBox__3-vGr","TimerContent":"Timer_TimerContent__11WGZ"};